/* tslint:disable */
import {
  Category
} from '../index';

declare var Object: any;
export interface BudgetInterface {
  "name"?: string;
  "value"?: number;
  "typeid"?: number;
  "categoryid"?: number;
  "date"?: Date;
  "userid"?: number;
  "createdat"?: Date;
  "updatedat"?: Date;
  "id"?: number;
  category?: Category;
}

export class Budget implements BudgetInterface {
  "name": string;
  "value": number;
  "typeid": number;
  "categoryid": number;
  "date": Date;
  "userid": number;
  "createdat": Date;
  "updatedat": Date;
  "id": number;
  category: Category;
  constructor(data?: BudgetInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Budget`.
   */
  public static getModelName() {
    return "Budget";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Budget for dynamic purposes.
  **/
  public static factory(data: BudgetInterface): Budget{
    return new Budget(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Budget',
      plural: 'Budgets',
      properties: {
        "name": {
          name: 'name',
          type: 'string'
        },
        "value": {
          name: 'value',
          type: 'number'
        },
        "typeid": {
          name: 'typeid',
          type: 'number'
        },
        "categoryid": {
          name: 'categoryid',
          type: 'number'
        },
        "date": {
          name: 'date',
          type: 'Date'
        },
        "userid": {
          name: 'userid',
          type: 'number'
        },
        "createdat": {
          name: 'createdat',
          type: 'Date'
        },
        "updatedat": {
          name: 'updatedat',
          type: 'Date'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
      },
      relations: {
        category: {
          name: 'category',
          type: 'Category',
          model: 'Category'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk-budget/models/Budget.ts